import React from 'react';
import Col from '../../Col';
import Input from '../../Input';
import File from '../../File';
import TextEditor from '../../Editor/Editor';
import { onCheckHeicDocument } from 'src/helpers/CommonHelpers';
import AttachmentList from '../../AttachmentList/AttachmentList';
import Callout from '../../InformationCallout/Callout';
import { MAX_ATTACHMENTS } from '../hooks/useAnnouncementFormOrchestrator';

interface AnnouncementDetailsSectionProps {
  title: string;
  description: any;
  attachments: any[];
  canAddAttachments: boolean;

  onTitleChange: (value: string) => void;
  onEditorChange: (editorState: any) => void;
  onSelectAttachments: (files: any) => void;
  onDeleteAttachment: (item: any) => void;
}

const AnnouncementDetailsSection = ({
  title,
  description,
  attachments,
  canAddAttachments,
  onTitleChange,
  onEditorChange,
  onSelectAttachments,
  onDeleteAttachment,
}: AnnouncementDetailsSectionProps) => {
  const attachmentCount: number = attachments?.length ?? 0;
  return (
    <Col xs="12" md="6">
      <Input
        value={title}
        onChange={(e: any) => onTitleChange(e.target.value)}
        label="Title"
        required
        placeholder="eg., Title"
        block
      />
      <div className="input">
        <div className="input__require">
          <label className="input__label">Description</label>
          <div className="input__required" />
        </div>
        <div className="input__control description-control">
          <TextEditor
            editorState={description}
            onEditorStateChange={onEditorChange}
          />
        </div>
      </div>
      <div className="announcement-attachments">
        <File
          label="Attachments"
          description={`${attachmentCount}/${MAX_ATTACHMENTS} files`}
          disabled={!canAddAttachments}
          onSelect={(file: any) =>
            onCheckHeicDocument(file) && onSelectAttachments(file)
          }
          files={[]}
          multiSelect={true}
          type={['image', 'pdf']}
        />
        {!canAddAttachments && (
          <Callout
            variant="error"
            title={`You've reached the ${MAX_ATTACHMENTS}-file limit`}
            subtitle={`An announcement can have at most ${MAX_ATTACHMENTS} attachments. Remove one to add another.`}
          />
        )}
        <AttachmentList
          attachments={attachments}
          onRemove={onDeleteAttachment}
        />
      </div>
    </Col>
  );
};

export default AnnouncementDetailsSection;
